const EVENT_NAME = 'appEvent'
const EPRINT_EVENT_PREFIX = 'eprint_'
const LOGIN_POPUP_EVENT_PREFIX = 'login_popup_'

// 印刷タイプのラベルマッピング
const PRINT_TYPE_LABELS = {
  1: '白黒片面A4_1枚',
  2: '白黒両面A4_1枚',
  4: '白黒片面A3_1枚',
  6: 'カラー片面A4_1枚',
  7: 'カラー片面A3_1枚',
  8: 'カラー片面B4_1枚',
  10: '白黒片面A4_2枚',
  11: '白黒両面A4_2枚',
  12: 'カラー片面A4_2枚',
  15: '写真プリント'
}

// 印刷タイプの価格マッピング
const PRINT_TYPE_PRICES = {
  1: 450,
  2: 450,
  4: 450,
  6: 450,
  7: 450,
  8: 450,
  10: 450,
  11: 450,
  12: 450,
  15: 450
}

// コンビニ店舗のラベルマッピング
const STORE_LABELS = {
  seven: 'セブンイレブン',
  others: 'ファミリーマート・ローソン等',
  lawson: 'ローソン'
}

// 決済方法のラベルマッピング
const PAYMENT_METHOD_LABELS = {
  stripe: 'クレジットカード',
  paypay: 'PayPay',
  postpaid: '店舗後払い'
}

const gtmDataLayer = {
  install: function (Vue, options) {
    const dataLayer = window.dataLayer || []

    Vue.prototype.$gtm = {
      // 既存メソッド: エラー通知
      sendError: function (action, label) {
        dataLayer.push({
          event: EVENT_NAME,
          eventCategory: 'appError',
          eventAction: action || 'defaultAction',
          eventLabel: label || 'defaultLabel'
        })
      },

      // コンビニプリント専用: イベント送信
      sendEprintEvent: function (eventName, params = {}) {
        const baseParams = {
          event: EPRINT_EVENT_PREFIX + eventName,
          timestamp: new Date().toISOString(),
          device_type: (Vue.prototype.$deviceLib && Vue.prototype.$deviceLib.isMobileDevice) ? 'SP' : 'PC',
          app_flag: (Vue.prototype.$site && Vue.prototype.$site.appFlag) || '',
          is_authenticated: (Vue.prototype.$firebase && Vue.prototype.$firebase.isAuthenticated) || false
        }

        dataLayer.push({
          ...baseParams,
          ...params
        })

        // デバッグログ（開発環境のみ）
        if (process.env.NODE_ENV === 'development') {
          console.log('[GTM Eprint Event]', eventName, { ...baseParams, ...params })
        }
      },

      // 完了画面のログインポップアップ専用: イベント送信
      sendLoginPopupEvent: function (eventName, params = {}) {
        const baseParams = {
          event: LOGIN_POPUP_EVENT_PREFIX + eventName,
          timestamp: new Date().toISOString(),
          device_type: (Vue.prototype.$deviceLib && Vue.prototype.$deviceLib.isMobileDevice) ? 'SP' : 'PC',
          is_authenticated: (Vue.prototype.$firebase && Vue.prototype.$firebase.isAuthenticated) || false
        }

        dataLayer.push({
          ...baseParams,
          ...params
        })

        // デバッグログ（開発環境のみ）
        if (process.env.NODE_ENV === 'development') {
          console.log('[GTM LoginPopup Event]', eventName, { ...baseParams, ...params })
        }
      },

      // コンビニプリント専用: GA4 Eコマースイベント（決済成功時）
      sendEprintPurchase: function (transactionData) {
        if (window.gtag) {
          window.gtag('event', 'purchase', {
            transaction_id: transactionData.transaction_id,
            value: transactionData.value,
            currency: 'JPY',
            items: [{
              item_id: transactionData.print_type,
              item_name: transactionData.product_name || PRINT_TYPE_LABELS[transactionData.print_type] || 'コンビニプリント',
              item_category: 'コンビニプリント',
              price: transactionData.value,
              quantity: 1
            }]
          })
        }

        // dataLayerにも送信（GTM連携用）
        dataLayer.push({
          event: 'eprint_purchase',
          ecommerce: {
            transaction_id: transactionData.transaction_id,
            value: transactionData.value,
            currency: 'JPY',
            items: [{
              item_id: transactionData.print_type,
              item_name: transactionData.product_name || PRINT_TYPE_LABELS[transactionData.print_type] || 'コンビニプリント',
              item_category: 'コンビニプリント',
              price: transactionData.value,
              quantity: 1
            }]
          }
        })

        if (process.env.NODE_ENV === 'development') {
          console.log('[GTM Eprint Purchase]', transactionData)
        }
      },

      // ファネルセッションID生成
      generateFunnelSessionId: function () {
        return 'eprint_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9)
      },

      // 印刷タイプのラベル取得
      getPrintTypeLabel: function (printType) {
        return PRINT_TYPE_LABELS[printType] || `印刷タイプ${printType}`
      },

      // 印刷タイプの価格取得
      getPrintTypePrice: function (printType) {
        return PRINT_TYPE_PRICES[printType] || 450
      },

      // コンビニ店舗のラベル取得
      getStoreLabel: function (storeKey) {
        return STORE_LABELS[storeKey] || storeKey
      },

      // 決済方法のラベル取得
      getPaymentMethodLabel: function (methodKey) {
        return PAYMENT_METHOD_LABELS[methodKey] || methodKey
      }
    }
  }
}
export default gtmDataLayer
